module.exports = __webpack_public_path__ + "img/647caa2.jpg";